import { useState, useEffect } from 'react';
import { GeolocationUtils } from '../utils/GeolocationUtils';

interface UserCoords {
    latitude: number;
    longitude: number;
}

export const useLocationForSorting = () => {
    const [userCoords, setUserCoords] = useState<UserCoords | null>(null);
    const [locationError, setLocationError] = useState<string | null>(null);
    const [loadingLocation, setLoadingLocation] = useState<boolean>(false);

    useEffect(() => {
        const getUserLocation = async () => {
            if (userCoords) return;

            setLoadingLocation(true);
            setLocationError(null);

            const result = await GeolocationUtils.getCurrentLocationSafe();

            if (result.success && result.coords) {
                setUserCoords(result.coords);
            } else {
                console.warn('Failed to get user location:', result.error);
                setLocationError(result.error || 'Unable to get location for distance sorting');
            }

            setLoadingLocation(false);
        };

        getUserLocation();
    }, [userCoords]);

    return { userCoords, locationError, loadingLocation };
};